import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { FlexColumn, FlexColumnCenter } from '../Flex';
import { smallBodySemiBold } from '../Typography';
import { Loader } from '../Loader';
import { scrollbar, responsiveColumn, media } from '../../style';

const Wrapper = styled(FlexColumn)`
  ${responsiveColumn.tablet}
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  ${scrollbar};
  background: ${({ theme }) => theme.colors.surface};
  padding: 10px;
  z-index: 2;

  ${media.tablet`
    position: relative;
    width: 250px;
    border-right: 1px solid ${({ theme }) => theme.colors.gray900};
    z-index: 1;
  `}
`;

const LoaderWrapper = styled(FlexColumnCenter)`
  flex: 1;
`;

const Link = styled(NavLink)`
  ${smallBodySemiBold};
  padding: 13px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.gray200};
  position: relative;
  white-space: nowrap;
  ${media.tablet`white-space: normal; padding: 13px 13px 13px 30px;`}

  &.active {
    color: ${({ theme }) => theme.colors.primarySemiLight};
    background: ${({ theme }) => theme.colors.backgroundLight};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primarySemiLight};
  }
`;

const Div = styled.div`
  cursor: default;
  &:hover {
    color: inherit;
  }
`;

const SubLinks = styled(FlexColumn)`
  ${responsiveColumn.tablet}

  > ${Link} {
    padding: 13px;
    ${media.tablet`padding: 13px 13px 13px 60px;`}
  }
`;

const SideBar = ({ isLoading, links, asLink }) => (
  <Wrapper>
    {isLoading && (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    )}

    {links.map(({ name, to, subLinks }, index) => (
      <React.Fragment key={index}>
        <Link to={to} as={to ? asLink : Div}>
          {name}
        </Link>
        <SubLinks>
          {subLinks?.map(({ name, to }, index) => (
            <Link to={to} as={asLink} key={index}>
              {name}
            </Link>
          ))}
        </SubLinks>
      </React.Fragment>
    ))}
  </Wrapper>
);

export default SideBar;
